import { forwardRef } from 'react';

import { IconButton, IconButtonProps } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import {
  RiArrowUpSLine as ExpandLess,
  RiArrowDownSLine as ExpandMore,
} from '@remixicon/react';
import classNames from 'classnames';

import { useSectionContext } from './SectionContext';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SectionExpandButtonProps
  extends Omit<IconButtonProps, 'classes' | 'onClick'>,
    WithStyles<typeof styles> {}

const SectionExpandButtonMui = forwardRef<
  HTMLButtonElement,
  SectionExpandButtonProps
>((props, ref) => {
  const { className, classes, ...rest } = props;
  const { expanded, onToggle } = useSectionContext();

  return (
    <IconButton
      size="small"
      onClick={onToggle}
      className={classNames(className, classes.root)}
      data-track-id="button.expand-section"
      data-track-action={expanded ? 'collapse' : 'expand'}
      data-track-source-anchor="1f482fda6d;section-expand-button-mui-icon-button;low" {...rest}
      ref={ref}
    >
      {expanded ? <ExpandLess /> : <ExpandMore />}
    </IconButton>
  );
});

SectionExpandButtonMui.displayName = 'SectionMui.ExpandButton';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default withStyles(styles)(SectionExpandButtonMui);
